import * as React from "react";
import {ChildrenType} from "../../_definitions/styleteq";
import * as classNames from "classnames";
import {toggleBodyScroll} from "../../_helpers/utils";

export const ModalSizes = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    MEDIUMLARGE: 'medium-large',
    LARGE: 'large',
    FULL: 'full'
};

interface Props {
    className?: string;
    size?: string;
    show: boolean;
    children?: ChildrenType;
    onExit?: () => void;
}

const ModalComponent = ({show, children, className, size, onExit}: Props) => {
    toggleBodyScroll(!show);
    if (!show)
        return null;

    const modalClass = classNames('reveal paddingless', className, size)
    return (
        <div className="reveal-overlay react-reveal" onClick={onExit}>
            <div className="wrapper">
                <div className={modalClass} role="dialog" onClick={(e) => e.stopPropagation()}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ModalComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/modal/ModalComponent.tsx